import {
	Box,
	Drawer,
	DrawerContent,
	DrawerOverlay,
	Flex,
	ModalCloseButton,
	Show,
	useDisclosure,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { P2PTradingClient } from 'skychain-p2p-trading-js';
import { ExecuteOrderStatus } from 'skychain-p2p-trading-js/lib/dto/execute-order.dto';
import { AdOrderEntity } from 'skychain-p2p-trading-js/lib/entities/ad-order.entity';
import { ExecuteOrderEntity } from 'skychain-p2p-trading-js/lib/entities/execute-order.entity';
import { UserIdentityClient } from 'user-identity-js';
import { UserEntity } from 'user-identity-js/lib/entities';
import Chat from '../components/BuySellDetail/Chat';
import Information from '../components/BuySellDetail/Information';
import StatusBar from '../components/BuySellDetail/StatusBar';
import StepBuySells from '../components/BuySellDetail/Steps';
import Container from '../layouts/Container';
import { RootState } from '../redux/store';

const BuySellDetailPage = () => {
	const { id } = useParams();
	const p2pTradingClient = useSelector(
		(state: RootState) => state.system.p2pTradingClient
	);
	const userIdentity = useSelector(
		(state: RootState) => state.system.userIdentity
	);
	const [orderDetail, setOrderDetail] = useState<ExecuteOrderEntity>();
	const [adOrderDetail, setAdOrderDetail] = useState<AdOrderEntity>();
	const [loading, setLoading] = useState(false);
	const [counterpart, setCounterpart] = useState<UserEntity>();
	const [activeStep, setActiveStep] = useState(1);
	const {
		isOpen: isOpenChat,
		onOpen: onOpenChat,
		onClose: onCloseChat,
	} = useDisclosure();

	useEffect(() => {
		if (id && p2pTradingClient) {
			getExecuteOrderDetail(p2pTradingClient, id);
		}
	}, [id, p2pTradingClient]);

	useEffect(() => {
		if (orderDetail?.adOrderId && p2pTradingClient) {
			getAdOrderDetail(p2pTradingClient, orderDetail.adOrderId);
		}
	}, [orderDetail]);

	useEffect(() => {
		if (adOrderDetail?.user && userIdentity) {
			getCounterPartInfo(userIdentity, adOrderDetail.user);
		}
	}, [adOrderDetail, userIdentity]);

	const getCounterPartInfo = async (
		userIdentity: UserIdentityClient,
		userId: string
	) => {
		try {
			const res = await userIdentity.getUser(userId);
			setCounterpart(res);
		} catch (error: any) {
			console.log('getUserInfo', error);
		}
	};

	const getAdOrderDetail = async (
		p2pTradingClient: P2PTradingClient,
		orderId: string
	) => {
		try {
			const res = await p2pTradingClient.getAdOrder(orderId);
			setAdOrderDetail(res);
		} catch (error: any) {
			console.log('getAdOrderDetail', error);
		} finally {
			setLoading(false);
		}
	};

	const getActiveStep = (status: ExecuteOrderStatus) => {
		switch (status) {
			case ExecuteOrderStatus.WAITING:
				return 1;
			case ExecuteOrderStatus.CONFIRM_PAYMENT:
				return 2;
			case ExecuteOrderStatus.CONFIRM_SUCCESS:
				return 3;
			default:
				return 1;
		}
	};
	const getExecuteOrderDetail = async (
		p2pTradingClient: P2PTradingClient,
		orderId: string
	) => {
		try {
			setLoading(true);
			const res = await p2pTradingClient.getExecuteOrder(orderId);
			setActiveStep(getActiveStep(res.status));
			setOrderDetail(res);
		} catch (error: any) {
			setLoading(false);
			console.log('getExecuteOrderDetail', error);
		}
	};

	const refresh = () => {
		if (id && p2pTradingClient) {
			getExecuteOrderDetail(p2pTradingClient, id);
		}
	};

	return (
		<>
			{loading ? (
				<div>Loading....</div>
			) : (
				orderDetail &&
				adOrderDetail && (
					<div>
						<StatusBar
							id={id as string}
							createdAt={orderDetail.createdAt}
							assetSymbol={adOrderDetail.assetSymbol}
							counterpart={
								counterpart?.email ||
								(counterpart?.firstName || '')
									.concat(' ')
									.concat(counterpart?.lastName || ' ')
							}
							type={orderDetail.type}
							user={adOrderDetail.user}
							timeLimit={adOrderDetail.timeLimit}
							status={orderDetail.status}
							amount={orderDetail.amount}
							onOpenChat={onOpenChat}
						/>
						<Container py={'30px'}>
							<Flex
								flexDir={{ base: 'column', md: 'row' }}
								justifyContent={'space-between'}
							>
								<Box>
									<StepBuySells
										type={orderDetail.type}
										stepNumberActive={activeStep}
									/>
									<Information
										executeOrder={orderDetail}
										adOrderDetail={adOrderDetail}
										counterpart={
											counterpart?.email ||
											(counterpart?.firstName || '')
												.concat(' ')
												.concat(counterpart?.lastName || ' ')
										}
										refresh={refresh}
									/>
								</Box>
								<Box display={{ base: 'none', md: 'block' }}>
									<Chat
										counterpart={
											counterpart?.email ||
											(counterpart?.firstName || '')
												.concat(' ')
												.concat(counterpart?.lastName || ' ')
										}
										status={adOrderDetail.status}
										groupId={orderDetail.id}
									/>
								</Box>

								<Show below="md">
									<Drawer
										placement={'bottom'}
										onClose={onCloseChat}
										isOpen={isOpenChat}
									>
										<DrawerOverlay />
										<DrawerContent bg={'transparent'}>
											<ModalCloseButton />
											<Chat
												counterpart={
													counterpart?.email ||
													(counterpart?.firstName || '')
														.concat(' ')
														.concat(counterpart?.lastName || ' ')
												}
												status={adOrderDetail.status}
												groupId={orderDetail.id}
											/>
										</DrawerContent>
									</Drawer>
								</Show>
							</Flex>
						</Container>
					</div>
				)
			)}
		</>
	);
};

export default BuySellDetailPage;
